export const initAddressBookState = () => {
    return {
        addresses: undefined,
        fetching: false,
        error: false
    }
}

export type Address = {
    externalAddress?: string
    lastName: string
    primaryShipping: string
    state: string
    addressType: string
    email1: string
    phone1: string
    addressId: string
    country: string
    city: string
    addressLine: Array<string>
    primaryBilling: string
    contactStoreIdentifier: string
    nickName: string
    zipCode: string
    firstName: string
    isDeleted?: boolean
    loading?: boolean
    loadError?: boolean
}

export type AddressBook = {
    addresses?: Array<Address>
    fetching: boolean
    error?: boolean
}
